"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Returns true if the passed action should result in opening the link in a new tab
 */
var _default = function _default(action) {
  if (["youtube_video", "external_link"].includes(action.type)) {
    return true;
  }
  // now we check for the URL of the link and match to the hostname of this website
  if (typeof window === "undefined") {
    return true; // No window? Default to new tab
  }

  try {
    var thisUrl = new URL(window.location.href);
    var actionUrl = new URL(action.url);
    // if the hostnames are not the same, this is considered an external link (thus returning true for a non-match)
    return thisUrl.hostname !== actionUrl.hostname;
  } catch (err) {
    // Any issue with checking the URL? Return true
    return true;
  }
};
exports.default = _default;